/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/duihao.png';
import _imports_1 from '@/assets/rightarrowactive.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1fdddcfd"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "w-100% color-#121212 flex flex-items-center justify-between itembox"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "font-size-28px font-600"
};
var _hoisted_6 = {
  "class": "color-#225eef mr-10px"
};
var _hoisted_7 = {
  "class": "color-#121212"
};
var _hoisted_8 = {
  "class": "subtitle"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "divider pos-relative"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "w-26px h-3px bg-black pos-absolute left-0 bottom-0"
  })], -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "class": "h22px w-auto mr-10px"
  }, null, -1);
});
var _hoisted_11 = {
  "class": "color-#333333"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "了解详情", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    "class": "h-20px w-auto"
  }, null, -1);
});
var _hoisted_14 = [_hoisted_12, _hoisted_13];
export default {
  __name: 'indexProjectItemLeft',
  props: {
    item: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    num: {
      type: Number,
      "default": 0
    }
  },
  emits: ['handleClick'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      item = _toRefs.item,
      num = _toRefs.num;
    var emit = __emit;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(item).img.length === 1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(item).img[0],
        "class": "w-600px h-auto"
      }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).img, function (v, i) {
        return _openBlock(), _createElementBlock("div", {
          key: i
        }, [_createElementVNode("img", {
          "class": _normalizeClass(["w-600px h-auto", i == 0 ? '' : 'mt-30px']),
          src: v
        }, null, 10, _hoisted_4)]);
      }), 128))])), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, "0" + _toDisplayString(_unref(num)), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(item).title), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(item).subtitle), 1), _hoisted_9, _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).introduction, function (v, i) {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          "class": "flex flex-items-center mt-15px"
        }, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(v), 1)]);
      }), 128))]), _createElementVNode("div", {
        "class": "btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('handleClick');
        })
      }, _hoisted_14)])]);
    };
  }
};